module.exports = __webpack_public_path__ + "static/media/test3_2.d4328b7f.png";